import {
    ChangeDetectionStrategy,
    Component, computed, effect, inject, input, SecurityContext, signal,
    ViewEncapsulation
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { DesanitizeSlashPipe } from '../../../../security';
import { CachedUrlResolverPipe } from '../../../pipes';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { IButtonWithDotBlok } from './button-with-dot.model';
import { DomSanitizer } from '@angular/platform-browser';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLinkPipe } from '@seven1/angular-storyblok-components/cta';

@Component({
    selector: 'app-button-with-dot',
    imports: [MatIconModule, RouterLink, DesanitizeSlashPipe, CachedUrlResolverPipe, NgTemplateOutlet, RouterLinkPipe],
    templateUrl: './button-with-dot.component.html',
    styleUrl: './button-with-dot.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { '[class]': 'getAllClasses()' },
})
export class ButtonWithDotComponent {
    private _tailwind = inject(TailwindService);
    private _sanitizer = inject(DomSanitizer);

    block = input.required<IButtonWithDotBlok>();
    click = input<(ev: MouseEvent | KeyboardEvent | TouchEvent) => void>((ev: MouseEvent | KeyboardEvent | TouchEvent) => {
        ev.stopPropagation();
    });

    sanitizedLink = signal<string | null>(null);

    getAllClasses = computed<string[]>(() => {
        const block = this.block();
        return [
            'flex',
            ...this._tailwind.getFlexboxClasses({
                flexJustify: block.align,
                flexJustifyTablet: block.alignTablet,
                flexJustifyDesktop: block.alignDesktop,
            }),
            ...this._tailwind.getSpacingClasses(block),
            ...this._tailwind.getDisplayClasses(block, 'flex'),
        ];
    });

    constructor() {
        effect(() => {
            const block = this.block();
            this.sanitizedLink.set(this._sanitizer.sanitize(SecurityContext.URL, block.link?.url || null));
        });
    }
}
